import { render } from "./ProformaCorpCard.vue?vue&type=template&id=2d205df3"
import script from "./ProformaCorpCard.vue?vue&type=script&lang=js"
export * from "./ProformaCorpCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__